/** @format */

import Cookies from "./../library/Cookies";
import LazyLoad from "./../library/LazyLoad";
import Forms from "./Forms";
import Zoom from "./Zoom";
import Carousels from "./Carousels";
import Filters from "./Shop/Filters";

export default class Popups {
	constructor() {
		this.instance = self;
		this.popupOptions = {
			removalDelay: 500,
			closeOnBgClick: false,
			mainClass: "mfp-slide-out",
			callbacks: {
				open: function () {
					$("body").addClass("popup-open");
				},
				ajaxContentAdded: function () {
					Forms.setResolutionInputs();
					Forms.initRangeSlider($(".popup .js-range-slider"));
					Forms.initSelectPlugin($(".popup .js-select2"));
					$("body").addClass("popup-open");
				},
				close: function () {
					$("body").removeClass("popup-open");
				},
			},
		};
	}

	static init() {
		const self = new Popups();
		self.attachEvents();
	}

	attachEvents() {
		const self = this;
		let urlHash = window.location.hash;

		if (urlHash.indexOf("#popup-") !== -1) {
			let urlHashParts = urlHash.split("#popup-"),
				popupUrl = urlHashParts[1];

			self.openAjaxPopup(popupUrl);
		}

		// ensure popupUrl isn't set on page load as we have no popup open
		Cookies.deleteCookie("popupUrl");

		window.site.openAjaxPopup = function (url) {
			self.openAjaxPopup(url);
		};

		$(document).on("click", ".js-popup", function (e) {
			e.preventDefault();
			self.openAjaxPopup($(this).attr("href"));
		});

		$(document).on("click", ".js-popup-basket", function (e) {
			e.preventDefault();
			self.openAjaxBasketPopup($(this).attr("href"));
		});

		$(document).on("click", ".js-popup-central", function (e) {
			e.preventDefault();
			self.openAjaxCentralPopup($(this).attr("href"));
		});

		$(document).on("click", ".js-popup-bottom", function (e) {
			e.preventDefault();
			self.openAjaxBottomPopup($(this).attr("href"));
		});

		$(document).on("click", ".js-popup-central-full", function (e) {
			e.preventDefault();
			self.openAjaxCentralFullPopup($(this).attr("href"));
		});

		$(document).on('click', '.make-big', function() {
			$(this).parent().siblings()[0].click()
		});

		$(document).on("click", ".size-guide-tabs p", function (e) {
			const $tab = $(this);

			if ($tab.hasClass("active")) {
				return;
			}

			$tab.siblings().removeClass("active");
			$tab.addClass("active");

			const $sizeGuide = $tab.closest(".size-guide");

			if ($tab.hasClass("how-to-measure")) {
				$sizeGuide.find(".js-size-guide").hide();
				$sizeGuide.find(".js-how-to-measure").show();
			} else {
				$sizeGuide.find(".js-how-to-measure").hide();
				$sizeGuide.find(".js-size-guide").show();
			}
		});

		$(document).on("click", ".js-popup-inline", function (e) {
			e.preventDefault();
			self.openInlinePopup($(this).attr("href"));
		});

		$(document).on("click", ".js-popup-filters", function (e) {
			e.preventDefault();
			self.openFiltersPopup($(this).attr("href"));
		});

		$(".js-gallery-popup").each(function () {
			self.openGalleryPopup($(this), ".js-gallery-popup");
		});

		// prevent default to stop # from being appended to url
		$(document).on("click", ".js-close-popup", function (e) {
			e.preventDefault();

			if ($.magnificPopup.instance && $.magnificPopup.instance.isOpen) {
				$.magnificPopup.instance.close();
			} else if ($("body").hasClass("popup-standalone")) {
				window.location.href = window.site.baseUrl;
			}
		});

		$(document).on("mousedown", ".mfp-container", function (e) {
			$.magnificPopup.instance.close();
		});

		$(document).on("mousedown", ".popup", function (e) {
			e.stopPropagation();
		});

		$(document).on("click", ".js-on-close-popup-submit-form", function (e) {
			e.preventDefault();

			$.magnificPopup.instance.close();

			const formSelector = $(this).data("form");

			// Delay to ensure popup is closed and can find elem
			setTimeout(function () {
				const $form = $(formSelector);

				$form.submit();
			}, 0);
		});
	}

	openAjaxPopup(url) {
		const self = this;

		self.openPopup({
			items: { src: url },
			type: "ajax",
			mainClass: "mfp-slide-out",
		});
	}

	openAjaxBasketPopup(url) {
		const self = this;

		self.openPopup({
			items: { src: url },
			type: "ajax",
			is_basket: true,
			mainClass: "mfp-slide-out",
		});
	}

	openAjaxCentralPopup(url) {
		const self = this;

		self.openPopup({
			items: { src: url },
			type: "ajax",
			mainClass: "mfp-zoom-out",
		});
	}

	openAjaxCentralFullPopup(url) {
		const self = this;

		self.openPopup({
			items: { src: url },
			type: "ajax",
			mainClass: "mfp-zoom-out mod-full",
		});
	}

	openAjaxBottomPopup(url) {
		const self = this;

		self.openPopup({
			items: { src: url },
			type: "ajax",
			mainClass: "mfp-slide-up",
		});
	}

	openInlinePopup(id) {
		const self = this;

		self.openPopup({
			items: { src: id },
			type: "inline",
			mainClass: "mfp-slide-out",
		});
	}

	openInlineCentralPopup(id) {
		const self = this;

		self.openPopup({
			items: { src: id },
			type: "inline",
			mainClass: "mfp-zoom-out",
		});
	}

	openPopup(options) {
		const self = this;

		var magnificPopup = $.magnificPopup.instance,
			defaultOptions = self.popupOptions,
			popupOptions = Object.assign(defaultOptions, options);

		if (popupOptions.type == "ajax") {
			if (popupOptions.is_basket == true) {
				popupOptions.callbacks.beforeOpen = function () {
					$(".basket-loading").fadeIn(250);

					setTimeout(function () {
						// do nothing wait for loading
					}
					, 1500);
				};

				popupOptions.callbacks.open = function () {
					// do nothing wait for loading
				}
			}

			popupOptions.callbacks.ajaxContentAdded = function () {
				Forms.setResolutionInputs();
				Forms.initRangeSlider($(".popup .js-range-slider"));
				Forms.initSelectPlugin($(".popup .js-select2"));
				LazyLoad.watchNewElement(".popup [data-lazy-img]");
				LazyLoad.watchNewElement(".popup [data-lazy-svg]");
				LazyLoad.watchNewElement(".popup .js-tooltip-trigger");
				Cookies.setCookie("popupUrl", popupOptions.items.src, 1);

				$(".popup .js-zoom-img").each(function () {
					Zoom.initZoom($(this));
				});

				$(".popup .js-carousel").each(function () {
					Carousels.initCarousel($(this));
				});
				$("body").addClass("popup-open");
				$(".basket-loading").fadeOut(300);

				$(document).trigger("popupOpen", [popupOptions]);
			};

			popupOptions.callbacks.close = function () {
				$("body").removeClass("popup-open");
				Cookies.deleteCookie("popupUrl");
			};
		}

		if (magnificPopup.isOpen == true) {
			magnificPopup.close();

			setTimeout(function () {
				$.magnificPopup.open(popupOptions);
			}, 500);
		} else {
			$.magnificPopup.open(popupOptions);
		}
	}

	openFiltersPopup(url) {
		const self = this;

		let magnificPopup = $.magnificPopup.instance,
			defaultOptions = self.popupOptions,
			options = {
				items: { src: url },
				type: "ajax",
			},
			popupOptions = Object.assign(defaultOptions, options);

		popupOptions.callbacks.ajaxContentAdded = function () {
			let filtersComp = new Filters();
			filtersComp.load();
			Cookies.setCookie("popupUrl", popupOptions.items.src, 1);
		};

		if (magnificPopup.isOpen == true) {
			magnificPopup.close();

			setTimeout(function () {
				$.magnificPopup.open(popupOptions);
			}, 500);
		} else {
			$.magnificPopup.open(popupOptions);
		}
	}

	openGalleryPopup($element, selector) {
		$element.magnificPopup({
			type: "image",
			delegate: selector,
			mainClass: "mfp-zoom-out",
			gallery: {
				enabled: true,
			},
			callbacks: {
				buildControls: function () {
					if (this.arrowLeft) {
						this.arrowLeft.appendTo(this.contentContainer);
					}

					if (this.arrowRight) {
						this.arrowRight.appendTo(this.contentContainer);
					}
				},
			},
		});
	}
}
